<template>
  <img :src="imageUrl" loading="lazy" decoding="async" height="40"
       style="border:1px solid #000;max-width:160px;object-fit:contain"
       alt="" @error="useOriginal">
</template>

<script>
export default {
  name: 'OssThumbnail',
  props: {
    record: { type: Object, required: true },
    field: { type: String, required: true },
    original: { type: String, required: true }
  },
  data () {
    return { failed: false }
  },
  computed: {
    thumbnail () {
      const originals = this.$ossField(this.record, this.field).split('|')
      const thumbnails = (this.record[this.field + '_thumb_signed'] || '').split('|')
      return thumbnails[originals.indexOf(this.original)] || this.original
    },
    imageUrl () {
      return this.failed ? this.original : this.thumbnail
    }
  },
  watch: {
    thumbnail () { this.failed = false }
  },
  methods: {
    useOriginal () { this.failed = true }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OssThumbnail.vue